<template>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div
            class="col-xxl-10 col-xl-10 col-lg-10 col-md-10 col-sm-12 mx-auto"
          >
            <div class="card-body">
              <h2 class="animate-characters">
                Explore the colorful Reaperville NFT collection on SmartBch!
              </h2>
              <h4>
                Which one is your favorite? Let us know in the
                <a href="https://t.me/reaperville" target="_blank"
                  >official Reaperville Telegram group</a
                >.
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="card filter-tab">
      <div class="card-body bs-0 p-0 bg-transparent">
        <div class="row">
          <div
            class="col-xxl-10 col-xl-10 col-lg-10 col-md-10 col-sm-12 mx-auto"
          >
            <div class="card-body">
              <button
                v-if="expandRange === false"
                class="btn btn-std"
                type="button"
                @click="expandRange = !expandRange"
              >
                Showing {{ startIdx }} - {{ startIdx + maxNftsPerPage - 1 }}
                <i class="ri-arrow-down-s-line"></i>
              </button>
              <button
                v-else
                class="btn btn-outline-std"
                type="button"
                @click="expandRange = !expandRange"
              >
                Showing {{ startIdx }} - {{ startIdx + maxNftsPerPage - 1 }}
                <i class="ri-arrow-up-s-line"></i>
              </button>

              &nbsp;

              <button
                v-if="expandMaxNftsPerPage === false"
                class="btn btn-std"
                type="button"
                @click="expandMaxNftsPerPage = !expandMaxNftsPerPage"
              >
                Max. {{ maxNftsPerPage }} NFTs
                <i class="ri-arrow-down-s-line"></i>
              </button>
              <button
                v-else
                class="btn btn-outline-std"
                type="button"
                @click="expandMaxNftsPerPage = !expandMaxNftsPerPage"
              >
                Max. {{ maxNftsPerPage }} NFTs
                <i class="ri-arrow-up-s-line"></i>
              </button>

              &nbsp;

              <button
                v-if="imgResolutionIdx > 0"
                class="btn btn-outline-std"
                type="button"
                @click="imgResolutionIdx = (imgResolutionIdx + 1) % 2"
              >
                Resolution: Full
              </button>

              <button
                v-else
                class="btn btn-std"
                type="button"
                @click="imgResolutionIdx = (imgResolutionIdx + 1) % 2"
              >
                Resolution: Low
              </button>

              <ul v-if="expandRange" class="mt-3">
                <hr class="my-0" />
                <a
                  v-for="n in Math.ceil(2500 / maxNftsPerPage)"
                  :key="n"
                  class="dropdown-item"
                  href="#"
                  @click="load((n - 1) * maxNftsPerPage + 1, maxNftsPerPage)"
                  :class="
                    startIdx === (n - 1) * maxNftsPerPage ? 'current' : ''
                  "
                >
                  Show {{ (n - 1) * maxNftsPerPage + 1 }} -
                  {{ Math.min(n * maxNftsPerPage, 2500) }}</a
                >
                <hr class="my-0" />
              </ul>

              <!-- <span v-for="n in Math.ceil(2500 / maxNftsPerPage)" :key="n">
                <button
                  @click="load(n, maxNftsPerPage)"
                  class="btn btn-std"
                >
                  {{ (n - 1) * maxNftsPerPage + 1 }} - {{ n * maxNftsPerPage }}
                </button>
                &nbsp;
              </span> -->

              <ul v-if="expandMaxNftsPerPage" class="mt-3">
                <hr class="my-0" />
                <a
                  class="dropdown-item"
                  href="#"
                  @click="load(startIdx, 10)"
                  :class="maxNftsPerPage === 10 ? 'current' : ''"
                  >Max. 10</a
                >
                <a
                  class="dropdown-item"
                  href="#"
                  @click="load(startIdx, 25)"
                  :class="maxNftsPerPage === 25 ? 'current' : ''"
                  >Max. 25</a
                >
                <a
                  class="dropdown-item"
                  href="#"
                  @click="load(startIdx, 50)"
                  :class="maxNftsPerPage === 50 ? 'current' : ''"
                  >Max. 50</a
                >
                <a
                  class="dropdown-item"
                  href="#"
                  @click="load(startIdx, 75)"
                  :class="maxNftsPerPage === 75 ? 'current' : ''"
                  >Max. 75</a
                >
                <a
                  class="dropdown-item"
                  href="#"
                  @click="load(startIdx, 125)"
                  :class="maxNftsPerPage === 125 ? 'current' : ''"
                  >Max. 125</a
                >
                <hr class="my-0" />
              </ul>
            </div>
          </div>
        </div>

        <br />

        <div class="row">
          <div
            class="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6"
            v-for="tokenId in filteredNfts"
            :key="tokenId"
          >
            <div class="card items">
              <div class="card-body">
                <label>
                  <h4 class="card-title">
                    #{{ tokenId }}
                    &nbsp;
                    <!-- <span title="current level"
                      >🏆{{ nftInfo[tokenId].level }}</span
                    >
                    &nbsp;
                    <span title="current staking power"
                      >🔥{{ powerForLevel[nftInfo[tokenId].level] }}</span
                    > -->
                  </h4>
                </label>
                <div class="items-img position-relative">
                  <img
                    :src="pictureLink[imgResolutionIdx] + tokenId + '.png'"
                    class="img-fluid rounded mb-3"
                  />
                </div>
                <!-- <div v-if="nftInfo[tokenId].level >= maxLevel">
                  Max. level reached!
                </div>
                <div v-else>
                  <div>
                    <span title="current level"
                      >🏆{{ nftInfo[tokenId].level }}</span
                    >
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  props: ["pictureLink", "projectname"],
  emits: ["updateStakingPowerEvent"],

  data() {
    return {
      expandRange: false,
      expandMaxNftsPerPage: false,

      maxLevel: 100,

      powerForLevel: [
        1000, 1050, 1104, 1162, 1224, 1291, 1363, 1440, 1523, 1613, 1710, 1815,
        1928, 2051, 2184, 2329, 2486, 2657, 2844, 3048, 3271, 3515, 3782, 4075,
        4397, 4730, 5074, 5428, 5792, 6165, 6546, 6934, 7329, 7730, 8136, 8546,
        8959, 9375, 9793, 10212, 10632, 11051, 11469, 11886, 12301, 12713,
        13122, 13527, 13928, 14324, 14715, 15101, 15481, 15855, 16223, 16584,
        16939, 17287, 17628, 17962, 18288, 18607, 18918, 19222, 19519, 19808,
        20090, 20364, 20631, 20891, 21143, 21391, 21634, 21873, 22107, 22336,
        22561, 22781, 22997, 23210, 23421, 23630, 23836, 24040, 24242, 24441,
        24638, 24833, 25025, 25215, 25402, 25587, 25770, 25950, 26128, 26304,
        26477, 26648, 26817, 26983, 27147,
      ],

      filteredNfts: [],
      maxNftsPerPage: 25,
      startIdx: 1,
      imgResolutionIdx: 0,
    };
  },

  methods: {
    // updateFilters: function () {
    //   that.filters = {}
    //   filters.Background = getSelectValues(document.getElementById("Background"));
    //   filters.Fur = getSelectValues(document.getElementById("Fur"));
    //   filters.Clothes = getSelectValues(document.getElementById("Clothes"));
    //   filters.Eyes = getSelectValues(document.getElementById("Eyes"));
    //   filters.Mouth = getSelectValues(document.getElementById("Mouth"));
    //   filters.Earring = getSelectValues(document.getElementById("Earring"));
    //   filters.Hat = getSelectValues(document.getElementById("Hat"));
    //   filters.Profile = getSelectValues(document.getElementById("Profile"));
    //   filters.Special = getSelectValues(document.getElementById("Special"));
    //   filters.trait_count = getSelectValues(document.getElementById("trait_count"));

    //   for (let nft of that.sts) {
    //     if (false == matchesAllFilters(nft, filters)) continue;
    //   }
    // },

    getInitialLevel: function (_tokenId) {
      // set initial level
      if (_tokenId < 10) {
        return 10;
      } else if (_tokenId == 2500) {
        return 0;
      } else {
        return 9 - Math.floor(_tokenId / 250);
      }
    },

    getPower: function (_tokenId) {
      return this.powerForLevel[this.nftInfo[_tokenId].level];
    },

    load: async function (_startIdx, _maxNftsPerPage) {
      let that = this;

      that.expandRange = false;
      that.expandMaxNftsPerPage = false;

      if (_startIdx < 1) {
        _startIdx = 1;
      }

      this.maxNftsPerPage = _maxNftsPerPage;
      this.startIdx = _startIdx;

      that.filteredNfts = [];
      for (
        let i = _startIdx;
        i < Math.min(_startIdx + _maxNftsPerPage, 2500);
        i++
      ) {
        that.filteredNfts.push(i);
      }

      console.log("calling filter");
      // that.filterNfts(that.filter);
    },
  },

  mounted: function () {
    this.load(1, this.maxNftsPerPage);
  },
};
</script>
